import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField/TextField';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { webConfig } from '../../../../webConfig';
import { useInvokeApi } from '../../utils/useInvokeApi';
import { textFieldWidth } from '../styles';
import locationIcon from '../../../../assets/location-icon.svg';
import { LocationSelected } from '../../../../store/signup/types';
import Autocomplete, {
    AutocompleteRenderInputParams,
} from '@material-ui/lab/Autocomplete/Autocomplete';
import { CLICK_ORG_NAME_CITY_INPUT } from 'utils/clevertapEvents';
import { pushEvent } from 'utils/clevertapUtils';

const findCityEndPoint = webConfig.findCityEndPoint;

const isZipCode = (value: string): boolean =>
    value.length === 5 && Number.isInteger(Number.parseInt(value));

export const isLocationValid = (location: LocationSelected): boolean => {
    return location.userTypedValue.length > 1;
    // const { term, city, state } = location;
    // if (term.length === 0) return false;
    // if (term.length === 5 && Number.isInteger(Number.parseInt(term)))
    //     return true;
    // if (city.length > 1 && state.length > 1) return true;
    // return false;
};

export interface City {
    suggest: string;
    suggestShort: string;
    city: string;
    state: string;
    spelledState: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        autoSuggestStyles: {
            maxWidth: textFieldWidth,
            '& .MuiAutocomplete-endAdornment': {
                display: 'none',
            },
            '& .MuiOutlinedInput-adornedStart': {
                paddingLeft: 0,
            },
            '& input': {
                borderColor: 'transparent',
            },
            '& .image': {
                padding: theme.spacing(0, 2),
            },
        },
    }),
);

interface LocationAutoCompleteProps {
    readOnly?: boolean;
    location: LocationSelected;
    onSubmit: (location: LocationSelected) => unknown;
    className?: string;
    onClick?: () => unknown;
}

const filterOptions = (x: City[]) => x;
const renderOption = (c: City) => c.suggest;

const LocationAutoComplete: React.FC<LocationAutoCompleteProps> = ({
    readOnly,
    location,
    onSubmit,
    onClick,
    // setCoordinates,
    className,
}) => {
    const [options, setOptions] = useState<City[]>([]);
    const [requestState, makeRequest] = useInvokeApi<City[]>();
    const { t } = useTranslation();
    const { autoSuggestStyles } = useStyles();
    const placeholder = useMemo(
        () => t('signup.organizationName.placeholders.location'),
        [t],
    );
    const handleLocationSelected = (e: unknown, city: City | string | null) => {
        if (!city) return;
        if (typeof city === 'string') {
            onSubmit({
                userTypedValue: city,
                city: '',
                state: '',
                zip: '',
            });
            return;
        }
        onSubmit({
            userTypedValue: city.suggest,
            city: city.city,
            state: city.state,
            zip: '',
        });
        pushEvent(CLICK_ORG_NAME_CITY_INPUT, { city_state_value: city.suggestShort });
    };
    const onChangeLocation = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        if (value.length > 1) {
            makeRequest('GET', findCityEndPoint + value);
        }
        onSubmit({
            userTypedValue: value,
            city: '',
            state: '',
            zip: isZipCode(value) ? value : '',
        });
    };
    useEffect(() => {
        if (requestState.type === 'REQUEST_SUCCESS') {
            setOptions(requestState.data);
        }
    }, [requestState]);
    // const useCurrentLocation = () => {
    //     getLocation((position: Position) => {
    //         setCoordinates(position.coords);
    //     });
    // };
    return (
        <Autocomplete
            freeSolo
            fullWidth={true}
            clearOnEscape
            closeIcon={null}
            popupIcon={null}
            filterOptions={filterOptions}
            options={options}
            renderOption={renderOption}
            getOptionLabel={renderOption}
            inputValue={location.userTypedValue}
            onChange={handleLocationSelected}
            className={className}
            renderInput={(params: AutocompleteRenderInputParams) => (
                <TextField
                    {...params}
                    variant="outlined"
                    fullWidth={true}
                    value={location.userTypedValue}
                    type="text"
                    placeholder={placeholder}
                    onChange={onChangeLocation}
                    className={autoSuggestStyles}
                    InputProps={{
                        ...params.InputProps,
                        readOnly,
                        startAdornment: (
                            <img
                                src={locationIcon}
                                title="use location"
                                alt="use location"
                                className="image"
                            />
                        ),
                    }}
                    onClick={onClick}
                />
            )}
        />
    );
};

export default React.memo(LocationAutoComplete);
